<template>
  <ion-page>
    <ion-header>
      <ion-toolbar class="topbar">
        <ion-buttons slot="start">
          <ion-button @click="onConfirmCloseWrap">返回</ion-button>
        </ion-buttons>
        <ion-title>单词详解</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <iframe :src="src" frameborder="0" style="width: 100%; height: 100vh"></iframe>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButton,
  IonButtons,
} from "@ionic/vue";
import mqttServer from "@/js/mqtt"

export default {
  name: "EduParaphrase",
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButton,
    IonButtons,
  },
  props: ["word"],

  data() {
    return {
      src: undefined,
      instructData: {
        project: "lxll",
        page: "teachIndex",
        module: "EduParaphrase",
        userType: 1,
        data: null,
        fn: "",
        param: null,
        timestamp: " ",
      },
    };
  },

  mounted() {
    this.src = "https://dict.youdao.com/search?q=" + this.word + "&keyfrom=new-fanyi.smartResult";
    mqttServer.onMqttMessage(this.instructData.module, this.onMessageReceived)

  },
  methods: {
    onConfirmCloseWrap() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onConfirmClose",
          msgType: "function",
        })
        .then(async () => {
          this.onConfirmClose()
        })
    },
    // 处理消息
    async onMessageReceived(msg) {
      // 确保 msg.fn 是 this 上的有效函数
      if (typeof this[msg.fn] !== 'function') {
        throw new Error(`Method ${msg.fn} is not a function`);
      }

      try {
        // 根据 params 是否为数组决定如何调用方法
        if (Array.isArray(msg.params)) {
          await this[msg.fn](...msg.params);
        } else {
          await this[msg.fn](msg.params);
        }
        return true;
      } catch (error) {
        console.error('Error executing method:', error);
        throw error; // 或者根据需要处理错误
      }
    },

  }
};
</script>

<style scoped>
ion-toolbar.topbar {
  --background: #30b1b4 !important;
}

ion-list {
  background: none;
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 2.5vh;
  padding-bottom: 2.5vh;
}

ion-item-sliding.itemStyle {
  padding: 0;
  height: 15vh;
  width: 95vw;
  margin: 0 2.5vw 2.5vw 2.5vw;
}

.itemControl {
  padding: 0;
  border-radius: 8px;
  border: 1px solid #ccc;
  height: 100%;
  width: 100%;
}

.itemControlHover {
  --color: #fff;
  --background: #319cdd;
  width: 100%;
}

ion-item::part(native) {
  padding: 0;
  margin: 0;
  height: 100%;
}

ion-item::part(native):hover {
  color: #fff;
  background: #319cdd;
}

.enword {
  margin-left: 20px;
  font-size: 6vw;
  letter-spacing: 0.1vw;
  width: 60%;
}

.cnword {
  margin-left: 5vw;
  font-size: 4.5vw;
}

.start-button {
  margin-left: 15px;
}

.end-button {
  margin-right: 15px;
}

ion-item-options {
  height: 80%;
  width: 15rem;
  top: 10%;
}

ion-item-option {
  width: 6rem;
  font-size: 3vw;
  border-radius: 8px;
  margin: 10px;
}
</style>
